<script>
import { Line } from "vue-chartjs";
import { dateTicks } from "@/utils/dashboardCharts";

export default {
  name: "ChartLine",
  extends: Line,
  props: {
    data: { type: Object, required: true },
    options: { type: Object, default: null },
    styles: {
      type: Object,
      default: () => ({ position: "relative", height: "100%", width: "100%" }),
    },
  },
  watch: {
    data() {
      this.render();
    },
    options() {
      this.render();
    },
  },
  mounted() {
    this.render();
  },
  methods: {
    render() {
      this.renderChart(
        this.data,
        this.options || {
          responsive: true,
          maintainAspectRatio: false,
          legend: { position: "bottom" },
          layout: { padding: { top: 18, right: 8 } },
          scales: {
            xAxes: [{ ticks: dateTicks }],
            yAxes: [{ ticks: { beginAtZero: true } }],
          },
        }
      );
    },
  },
};
</script>
